import React from 'react';
import Alert from 'modules/shared/components/alert';

import './search-no-result.scss';

const SearchNoResult: React.FC<{ query: string; categoryName?: string; }> = ({ query, categoryName }) => {
    return (
        <div className="search-no-result">
            <Alert color="warning">
                Nie znalezliśmy wyników wyszukiwania dla zapytania “{query}”
                {categoryName ? ` w kategorii “${categoryName}“` : ''}
            </Alert>
        </div>
    );
};

export default SearchNoResult;
